<template>
    <tr class="row-mask">
        <td v-for="col in row.columns" :key="col.colId">
            <Column :col="col" :row="row" @colClick="clickHandler"></Column>
        </td>
    </tr>
</template>

<script>
import Column from "./column/Column";

export default {
    name: "Row",
    components: {
        Column
    },
    props: ["row"],
    methods: {
        clickHandler(data) {
            data.rowData = this.row;
            this.$emit("colClick", data);
        }
    }
};
</script>

<style lang="less" scoped>
.row-mask {
    border-bottom: 1px solid #e3ecf5;

    &:hover {
        background: rgba(217, 235, 246, 0.7);
    }
    &:last-child {
        border-bottom: none;
    }
    td {
        position: relative;
        padding: 11px 10px 12px 20px;
        box-sizing: border-box;
    }
}
</style>
